"use client";

import { useEffect } from "react";
import { Toaster as Sonner, toast, type ToasterProps } from "sonner";

const TOAST_INTERACTIVE_SELECTOR = "button,a,input,textarea,select,[role='button'],[data-close-button],[data-button]";

const Toaster = ({ ...props }: ToasterProps) => {
  useEffect(() => {
    const handleToastClick = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest("[data-sonner-toast]")) return;
      if (event.target.closest(TOAST_INTERACTIVE_SELECTOR)) return;

      toast.dismiss();
    };

    document.addEventListener("click", handleToastClick);
    return () => document.removeEventListener("click", handleToastClick);
  }, []);

  return (
    <Sonner
      theme="light"
      className="toaster group"
      closeButton
      duration={3500}
      toastOptions={{
        classNames: {
          toast: "cursor-pointer",
          closeButton: "cursor-pointer",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
